import React, { useState, useEffect, useRef } from 'react';
import { Link,} from 'react-router-dom';
//import { Link as LinkScroll } from 'react-scroll';
//import Select from 'react-select';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { getTokenInfo } from '../../../UseToken';
//import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

//import { List, arrayMove } from "react-movable";;


import EvaluationFile from './EvaluationFile';
import EvaluationMultipleChoice from './EvaluationMultipleChoice';
import EvaluationFreeAnswer from './EvaluationFreeAnswer';

import {
	reqGET,
	reqPOST,
	//reqDELETE,
	reqPUT,
	//reqFILE,
	//repo_banner_link,
	//content_language,
} from '../../../Utils';
//import Hosts from '../../../Hosts';

import { language } from './Language';
//import { reduce } from 'core-js/core/array';

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	//const [dados2, set_dados_2] = useState('');

	const [dados_module, set_dados_module] = useState([]);
	const [dados_module_evaluation, set_dados_module_evaluation] = useState([]);

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());
	
	const [id_formacao, set_id_formacao] = useState('')
	const [id_modulo, set_id_modulo] = useState('')
	const [id_sessao, set_id_sessao] = useState('')
	const [is_edit_evaluation, set_is_edit_evaluation] = useState(false)

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);

	//const [refresh, setRefresh] = useState(0);
	
	//const [isRedirect, setRedirect] = useState(false);

	//const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)

	//const add_trainers_permission = ('Administrador' === getTokenInfo().profile || 'Gestor de formações' === getTokenInfo().profile || 'Coordenador de formações' === getTokenInfo().profile);

	const [/*editorLoaded*/, setEditorLoaded] = useState(false);

	const [evaluation_type, set_evaluation_type] = useState('file');

	const fetch_id_info = async (id_serch, id_module, id_session) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				let aux = dados_module_evaluation

				set_dados(dados.current = res.data[0]);

				res.data[0].content[0].modules.forEach((v2) => {

					if(v2.id === id_module) {
						set_dados_module(v2);

						if(v2['evaluations'] !== undefined) {
							v2['evaluations'].forEach((v3, k3) => {
								if(k3 === id_session) {
									aux[k3] = v3;

									if(v3.type !== '')
									set_evaluation_type(v3.type)
								}; 
								//setRefresh(refresh + 1)
							})
						}
					}; 
				})
				set_dados_module_evaluation(aux);
				console.log(aux)

			})
			.catch(error => console.log(error))
	}

	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}

	useEffect(() => {
		//setEditorLoaded(true);
		clean_data();

		set_lang(localStorage.getItem('lang'))

		set_id_formacao(props.location.state.item['id_formation'])
		set_id_modulo(props.location.state.item['id_module'])
		set_id_sessao(props.location.state.item['id_session'])

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				//set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id_formation'], props.location.state.item['id_module'], props.location.state.item['id_session'])
					.then(() => {

						setLoading(false)
						setEditorLoaded(true);
					})
				return			
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}
	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {


					dados.current.info.date.modified.push(today_submit)

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit
					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/formation/course/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									//console.log(res.data)
									dados.current.id = res.data[0].id

									set_is_edit(true)
									//set_show_delete_button(true)
								})
								.catch(() => 404)

							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	/*function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				remove_content_from_menu(dados.current.id)

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => {
						
						props.history.push(endpoints.list);

					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};*/

	/*const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_content_nolang = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.content[0][name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_info_select = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name]['id'] = value)
		set_dados(dados.current.info[name]['name'] = '')
	}*/

	/*const handleSaveQuestions = (questions) => {

		console.log('QE', questions)

	}*/

	const remove_evaluation = (id_module, order) => {

		let aux = dados.current.content[0].modules

		aux.forEach((el) => {
			if(parseInt(el.id) === parseInt(id_module)) {
				el.evaluations.forEach((el_e, k_e) => {
					if(parseInt(k_e) === parseInt(order)) {
						console.log('remove', el_e)
						el_e.type = ''
						el_e.questions = []
					}
				})
			}
		})

		set_dados(dados.current.content[0].modules = aux)

	}

	return isloading ?
		
		<Loader />
		
		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].gest}</h2>
					<p>{language[lang].content} / {language[lang].content_gest}</p>
				</div>

				{console.log('DADOS FORMAÇÃO & MÓDULOS: ', dados.current)}
				{console.log('DADOS MÓDULO: ', dados_module)}
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row mb-5">

							<div className='col-12 border-bottom'>
								<h3 className="fw-bolder">{language[lang].formation}</h3>
							</div>
							<div className='col-12 mt-3'>
								<h4 className='fw-bold'>{dados.current.content[0].title}</h4>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].date_begin}&#58;&nbsp;
								</label>
								<span>
									{dados.current.info.date.begin.split('T')[0]}
								</span>
							</div>

						</div>
						<div className="row mb-5">

							<div className='col-12 border-bottom'>
								<h2 className="fw-bolder">{language[lang].content}</h2>
							</div>
							<div className='col-12 mt-3'>
								<h4 className='fw-bold'>{dados_module.name}</h4>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].sessions_number}&#58;&nbsp;
								</label>
								<span>
									{dados_module.sessions_number}
								</span>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].duration}&#58;&nbsp;
								</label>
								<span>
									{dados_module.duration}
								</span>
							</div>

							{
							dados_module.trainer !== undefined && dados_module.trainer.name !== '' ? (
								<div className='col-12 mt-3'>
									<label className='fw-bold'>
										{language[lang].trainer}&#58;&nbsp;
									</label>
									<span>
										{dados_module.trainer.name}
									</span>
								</div>
							) : null 
							}
						</div>

						<div className="row mb-5">
							<div className='col-12 border-bottom'>
								<h2 className="fw-bolder">{language[lang].evaluation}</h2>
							</div>
							<div className='col-12 mt-3'>
								{
								dados_module_evaluation.length > 0 ?
									dados_module_evaluation.map((el, k_el) => {
										if(el !== undefined && el !== null && el.type !== '' && is_edit_evaluation !== true) {
											if(el.type === 'free_answer') {
												return (
													<div key={k_el}>
														<h4 className='fw-bold'>
															{language[lang].evaluation_free_answer}
															<button type="button" className='btn btn-light ms-3 assec-btn-edit' onClick={() => set_is_edit_evaluation(true)}><i className="bi bi-pencil"></i></button>
															<button type="button" className='btn btn-light ms-3 assec-btn-remove' onClick={() => remove_evaluation(dados_module.id, k_el)}><i className="bi bi-x-lg"></i></button>
														</h4>
														{
														el.questions.length > 0 ?
															el.questions.map((el_q, k_q) => {
																return (
																	<div key={k_q}>
																		<label className='fw-bold'>{language[lang].free_answer_question + ' ' + (k_q + 1)}:</label>  {el_q.question}
																	</div>
																)
															})
														:
															null
														}
													</div>
												)
											}
											else if(el.type === 'file') {
												return (
													<div key={k_el}>
														<h4 className='fw-bold'>
															{language[lang].evaluation_file}
															<button type="button" className='btn btn-light ms-3 assec-btn-edit' onClick={() => set_is_edit_evaluation(true)}><i className="bi bi-pencil"></i></button>
															<button type="button" className='btn btn-light ms-3 assec-btn-remove' onClick={() => remove_evaluation(dados_module.id, k_el)}><i className="bi bi-x-lg"></i></button>
														</h4>
														{
														el.questions.length > 0 ?
															el.questions.map((el_q, k_q) => {
																return (
																	<div key={k_q}>
																		<label className='fw-bold'>{language[lang].evaluation_question + ' ' + (k_q + 1)}:</label>  {el_q.question}
																	</div>
																)
															})
														:
															null
														}
													</div>
												)
											}
											else if(el.type === 'multiple_choice') {
												return (
													<div key={k_el}>
														<h4 className='fw-bold'>
															{language[lang].evaluation_multiple_choice}
															<button type="button" className='btn btn-light ms-3 assec-btn-edit' onClick={() => set_is_edit_evaluation(true)}><i className="bi bi-pencil"></i></button>
															<button type="button" className='btn btn-light ms-3 assec-btn-remove' onClick={() => remove_evaluation(dados_module.id, k_el)}><i className="bi bi-x-lg"></i></button>
														</h4>
														{
														el.questions.length > 0 ?
															el.questions.map((el_q, k_q) => {
																return (
																	<div key={k_q}>
																		<label className='fw-bold'>{language[lang].evaluation_question + ' ' + (k_q + 1)}:</label>  {el_q.question}

																		{
																		el_q.answers.map((el_a, k_a) => {
																			return (
																				<p key={k_a}>
																					<strong>R{k_a + 1}:</strong> {el_a.answer}
																				</p>
																			)
																		})
																		}
																	</div>
																)
															})
														:
															null
														}
													</div>
												)
											}
											else {
												return null
											}
										}
										else {
											return (
												<div key={k_el}>
													<div className='mb-4'>
														<button type='button' className={evaluation_type === 'file' ? "btn btn-dark active me-2" : 'btn btn-light me-2'} onClick={() => set_evaluation_type('file')} >Envio de ficheiro</button> 
														<button type='button' className={evaluation_type === 'multiple_choice' ? "btn btn-dark active me-2" : 'btn btn-light me-2'} onClick={() => set_evaluation_type('multiple_choice')} >Escolha multipla</button> 
														<button type='button' className={evaluation_type === 'free_answer' ? "btn btn-dark active me-2" : 'btn btn-light me-2'} onClick={() => set_evaluation_type('free_answer')}>Resposta livre</button> 
													</div>

													<div className='mb-4'>
														{
														evaluation_type === 'file' ?
															<div className='file'>
																<EvaluationFile 
																	idFormation={id_formacao}
																	idModule={id_modulo}
																	idSession={id_sessao}
																	isEdit={is_edit_evaluation}
																/>
															</div>
														:
															null
														}
														{
														evaluation_type === 'multiple_choice' ?
															<div className='multiple_choice'>
																<EvaluationMultipleChoice 
																	idFormation={id_formacao}
																	idModule={id_modulo}
																	idSession={id_sessao}
																	isEdit={is_edit_evaluation}
																/>
															</div>
														:
															null
														}
														{
														evaluation_type === 'free_answer' ?
															<div className='free_answer'>
																<EvaluationFreeAnswer 
																	idFormation={id_formacao}
																	idModule={id_modulo}
																	idSession={id_sessao}
																	isEdit={is_edit_evaluation}
																/>
															</div>
														:
															null
														}
													</div>
												</div>
											)
										}
									})
								:
									<div>
										<div className='mb-4'>
											<button type='button' className={evaluation_type === 'file' ? "btn btn-dark active me-2" : 'btn btn-light me-2'} onClick={() => set_evaluation_type('file')} >Envio de ficheiro</button> 
											<button type='button' className={evaluation_type === 'multiple_choice' ? "btn btn-dark active me-2" : 'btn btn-light me-2'} onClick={() => set_evaluation_type('multiple_choice')} >Escolha multipla</button> 
											<button type='button' className={evaluation_type === 'free_answer' ? "btn btn-dark active me-2" : 'btn btn-light me-2'} onClick={() => set_evaluation_type('free_answer')}>Resposta livre</button> 
										</div>

										<div className='mb-4'>
											{
											evaluation_type === 'file' ?
												<div className='file'>
													<EvaluationFile 
														idFormation={id_formacao}
														idModule={id_modulo}
														idSession={id_sessao}
														isEdit={is_edit_evaluation}
													/>
												</div>
											:
												null
											}
											{
											evaluation_type === 'multiple_choice' ?
												<div className='multiple_choice'>
													<EvaluationMultipleChoice 
														idFormation={id_formacao}
														idModule={id_modulo}
														idSession={id_sessao}
														isEdit={is_edit_evaluation}
													/>
												</div>
											:
												null
											}
											{
											evaluation_type === 'free_answer' ?
												<div className='free_answer'>
													<EvaluationFreeAnswer 
														idFormation={id_formacao}
														idModule={id_modulo}
														idSession={id_sessao}
														isEdit={is_edit_evaluation}
													/>
												</div>
											:
												null
											}
										</div>
									</div>
								}
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								{/*<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>*/}
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>
		</main>

}
